import API from "shared/services/Api";
import { IAuthLogin, IAuthResponse } from "shared/types/Auth";

export const authLogin = async (data: IAuthLogin): Promise<IAuthResponse> =>
  API.post("login", data);

export const disconnect = async (id: string) => API.get(`disconnect?id=${id}`);
